import { cancelGridFade } from './cancelGridFade.js';
import { scheduleGridFade } from './scheduleGridFade.js';

export function updateGridOpacity() {
  if (!this._map) return;
  const layer = this, now = Date.now();
  let fading = false, prune = false;
  let tile;
  for (tile of Object.values(this._tiles || {})) {
    if (!tile.current || !tile.loaded) continue;
    tile._gpuOpacity = this._map._fadeAnimated ? Math.min(1, (now - tile.loaded) / 200) : 1;
    if (tile._gpuOpacity < 1) fading = true;
    else if (!tile.active) {
      this._onOpaqueTile(tile);
      tile.active = true;
      prune = true;
    }
  }
  if (prune && !this._noPrune) this._pruneTiles();
  this._nativeGPU?.refresh?.();
  cancelGridFade(layer);
  if (fading) scheduleGridFade(layer);
}
